import React, { useState } from "react";
import Styles from "./main.module.css";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import { getfranchiseForm } from "../../../Services/APIrequests";

const Signupmodal = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    mobileNumber: "",
    name: "",
    email: "",
    location: "",
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all fields are filled before submitting
    if (
      !formData.name ||
      !formData.mobileNumber ||
      !formData.email ||
      !formData.location
    ) {
      warningSwal("All fields are required.");
      return;
    }

    // Prepare the data in the format expected by the API
    const apiData = {
      name: formData.name,
      number: formData.mobileNumber,
      email: formData.email,
      location: formData.location,
    };

    try {
      // Call the API to submit the form data
      const response = await getfranchiseForm(apiData);

      if (
        response &&
        (response.status === 200 || response.status === 201) &&
        response.data &&
        response.data.message === "Franchise form created successfully"
      ) {
        SuccessSwal("Form submitted successfully!");
        closeModal(); // Close modal on success
      } else {
        console.error("Error: Unexpected response", response);
        warningSwal(
          response.data?.message || "There was an issue with the submission."
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      warningSwal("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className={Styles.modal}>
      <div className={Styles.modalContent}>
        <span className={Styles.close} onClick={closeModal}>
          &times;
        </span>
        <h2 className={Styles.modalheadingname}>Franchise Form</h2>
        <form onSubmit={handleSubmit}>
          <div className={Styles.formGroup}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter Your Name"
              required
            />
          </div>
          <div className={Styles.formGroup}>
            <label>Mobile Number</label>
            <input
              type="text"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleInputChange}
              placeholder="Enter Mobile Number"
              required
            />
          </div>
          <div className={Styles.formGroup}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter Your Email"
              required
            />
          </div>
          <div className={Styles.formGroup}>
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Enter Your Location"
              required
            />
          </div>
          <button type="submit" className={Styles.submitBtn}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Signupmodal;
